import React from 'react';
import {API_DEV_URL, API_SIT_URL, NODE_ENV_TYPE_DEVELOPMENT, NODE_ENV_TYPE_PRODUCTION} from "./ultilities";
import BaseApp from "./pages/BaseApp";
import {createBrowserRouter, RouterProvider} from "react-router";

const App = () =>  {

  const getBaseUrl = () => {
    let url
    switch (process.env.NODE_ENV) {
      case NODE_ENV_TYPE_DEVELOPMENT:
        url = API_DEV_URL
        break
      case NODE_ENV_TYPE_PRODUCTION:
        url = API_SIT_URL
        break
      default:
        break
    }
    return url
  }

  const router = createBrowserRouter([
    {
      path: "/",
      element: <BaseApp apiBaseUrl={getBaseUrl()} />,
    },
    {
      path: "/:userId",
      element: <BaseApp apiBaseUrl={getBaseUrl()} />,
    },
    // Các routes khác
  ]);


  return <RouterProvider router={router} />;
}

export default App;
